import React, { Component } from "react";
import { graphql } from "react-apollo";
import styled from "styled-components";
import { CustomerJourneyStore, GetCustomerJourneyFilter } from "Store";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { queryGetCustomerListPagination } from "Apollo";
import Filter from "./filter/FilterWithStore";
import List from "./list/List";
import Detail from "./detail/CustomerDetail";
import { Scrollbars } from "react-custom-scrollbars";
import LoadingPanel from "module-common/LoadingPanel";
import AbsoluteFlex from "module-common/AbsoluteFlex";
import moment from "moment";

const ListGraphql = graphql(queryGetCustomerListPagination)(
  observer(
    class ModuleCustomerJourneyView extends Component {
      state = {
        title: "Customer List",
        listCount: 0,
        selectedId: 0,
        customerDetail: false
      };
      states = observable({ loadingPagination: false });

      preprocessData = () => {
        const {
          data: { getCustomerListPagination: customerListConnection }
        } = this.props;
        const rows = [];
        if (customerListConnection) {
          for (let row of customerListConnection.edges) {
            const lastContact = row.node.channelHandler.lastStream
              ? moment(row.node.channelHandler.lastStream.dateCreated).format(
                  "DD MMMM YYYY"
                )
              : "No Last Contact";

            rows.push({
              id: row.node.channelHandler.id,
              name: row.node.name,
              avatar: row.node.channelHandler.displayPicture,
              lastContact: lastContact,
              channel: row.node.channelHandler.channel.name,
              labelsRaw: row.node.labels
            });
          }
          // sort by date
          // rows.sort(
          //   (a, b) => new Date(b.lastContact) - new Date(a.lastContact)
          // );
        }

        return rows;
      };

      render() {
        const { title, listCount, customerDetail } = this.state;
        const { data: { loading } } = this.props;
        const store = CustomerJourneyStore;

        const dataList = this.preprocessData();

        const renderLists = dataList.map((row, index) => (
          <List
            key={"list" + row.id}
            id={row.id}
            index={index + 1}
            avatar={row.avatar}
            channel={row.channel}
            name={row.name}
            lastContact={row.lastContact}
            icon={row.icon}
            labelsRaw={row.labelsRaw}
            onClick={id => this.onShowCustomerDetail(row.id)}
          />
        ));

        const ContentList = loading ? (
          <LoadingPanel />
        ) : (
          <Content>
            <FilterWrapper>
              <Filter key="filter" store={store} />
            </FilterWrapper>
            <ListWrapper>
              <ListTitle>
                <Index>No.</Index>
                <Name>Customer</Name>
                <Contact>Last Contact</Contact>
                <SocialMedia>Social Media</SocialMedia>
                <Label>Label</Label>
              </ListTitle>
              {renderLists}
            </ListWrapper>
          </Content>
        );

        const ContentDetail = (
          <Content>
            <Detail selectedId={this.state.selectedId} />
          </Content>
        );

        const BackToCustomerList = (
          <Back
            onClick={() =>
              this.setState({
                customerDetail: false
              })
            }
          >
            Back
          </Back>
        );

        if (loading) {
          return (
            <AbsoluteFlex>
              <LoadingPanel />
            </AbsoluteFlex>
          );
        } else {
          return (
            <Wrapper>
              <Header>
                <Title>
                  {customerDetail ? "Customer Detail" : "Customer List"}
                </Title>
                <Title>{customerDetail ? BackToCustomerList : ""}</Title>
              </Header>
              <Scrollbars
                ref={ref => (this.scroller = ref)}
                onScrollFrame={this.onScrollFrame}
              >
                {customerDetail ? ContentDetail : ContentList}
              </Scrollbars>
            </Wrapper>
          );
        }
      }
      onShowCustomerDetail = id => {
        this.setState({
          customerDetail: true,
          selectedId: id
        });
      };

      onScrollFrame = event => {
        // detect if on bottom scroll
        if (event.top >= 1) {
          this.onEndReached();
        }
      };

      onEndReached = async () => {
        const { data: { fetchMore, getCustomerListPagination } } = this.props;
        if (
          getCustomerListPagination &&
          getCustomerListPagination.edges.length > 0
        ) {
          if (!this.states.loadingPagination) {
            this.states.loadingPagination = true;
            const length = getCustomerListPagination.edges.length;
            const cursor = getCustomerListPagination.edges[length - 1].cursor;
            await fetchMore({
              variables: {
                after: cursor
              },
              updateQuery: (prevResult, { fetchMoreResult }) => {
                if (!fetchMoreResult) return prevResult;
                const result = Object.assign(
                  {},
                  prevResult.getCustomerListPagination,
                  {
                    edges: [
                      ...prevResult.getCustomerListPagination.edges,
                      ...fetchMoreResult.getCustomerListPagination.edges
                    ]
                  }
                );
                return { getCustomerListPagination: result };
              }
            });
            this.states.loadingPagination = false;
          }
        }
      };
    }
  )
);

export default observer(
  class ModuleCustomerJourney extends Component {
    render() {
      return <ListGraphql {...GetCustomerJourneyFilter()} />;
    }
  }
);

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  /* overflow: scroll; */
`;

const Header = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #d2d3d5;
`;

const Title = styled.div`
  font-size: 1.1rem;
  font-weight: 500;
  color: #087cbc;
`;

const Back = styled.span`
  cursor: pointer;
`;

const Content = styled.div`
  padding: 10px 20px;
`;

const FilterWrapper = styled.div`
  width: 400px;
`;

const ListWrapper = styled.div`
  margin-top: 10px;
`;

const ListTitle = styled.div`
  background: #20445a;
  color: #fff;
  font-weight: 600;
  font-size: 0.95rem;
  display: flex;
  flex-direction: row;
  padding: 5px 10px;
`;

const Index = styled.div`
  margin-left: 10px;
  flex: 1;
`;

const Name = styled.div`
  flex: 4;
`;

const Contact = styled.div`
  flex: 3;
`;

const SocialMedia = styled.div`
  flex: 2;
  text-align: center;
`;

const Label = styled.div`
  flex: 4;
  margin-right: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-customer-journey/ModuleCustomerJourney.js